import { useReducer } from 'react';
import { ReferencesContext, referencesReducer } from './';
import { Reference, ReferencesContextTypes } from '../../interfaces';

export interface ReferencesState {
  reference: Reference | null;
}

const References_INITIAL_STATE: ReferencesState = {
  reference: null
}

type ReferencesProviderProps = {
  children: JSX.Element[] | JSX.Element
}

export const ReferencesProvider = ({ children }: ReferencesProviderProps) => {
  const [state, dispatch] = useReducer(referencesReducer, References_INITIAL_STATE);

  /**
   * Agrega una nueva referencia al arreglo de referencias
   * @param reference Referencia a agregar
   */
  const addNewReference = (reference: Reference) => {
    dispatch({type: ReferencesContextTypes.ACTION_TYPE_SET_NEW_REFERENCE, payload: reference});
  }

  return (
    <ReferencesContext.Provider value={{
      ...state,
      addNewReference
    }}>
      { children }
    </ReferencesContext.Provider>
  )
}